import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/slices/snackbar/snackbar-slice';

interface SuccessSnackbarEffectProps {
    isSuccess?: boolean;
    message?: string;
}

const SuccessSnackbarEffect = ({
    isSuccess,
    message,
}: SuccessSnackbarEffectProps) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (isSuccess && message) {
            dispatch(
                openSnackbar({
                    message,
                    severity: 'success',
                    open: true,
                    position: {
                        vertical: 'top',
                        horizontal: 'center',
                    },
                }),
            );
        }
    }, [isSuccess, message, dispatch]);

    return null;
};

export default SuccessSnackbarEffect;
